import { HomeIcon } from '@heroicons/react/solid';
import Link from 'next/link';

export default function Breadcrumbs({
  pages,
}: {
  pages: { name: string; href: string; current: boolean }[];
}) {
  return (
    <nav className='flex' aria-label='Breadcrumb'>
      <ol role='list' className='flex items-center space-x-4'>
        <li>
          <div>
            <Link
              href='/'
              className='text-gray-400 dark:text-slate-500 hover:text-gray-500'
              passHref
              legacyBehavior
            >
              <HomeIcon className='h-5 w-5 flex-shrink-0' aria-hidden='true' />
            </Link>
          </div>
        </li>
        {pages.map((page) => (
          <li key={page.name}>
            <div className='flex items-center'>
              <svg
                className='h-5 w-5 flex-shrink-0 text-gray-300 dark:text-slate-500'
                xmlns='http://www.w3.org/2000/svg'
                fill='currentColor'
                viewBox='0 0 20 20'
                aria-hidden='true'
              >
                <path d='M5.555 17.776l8-16 .894.448-8 16-.894-.448z' />
              </svg>
              {page.href !== '' ? (
                <Link
                  href={page.href}
                  className='ml-4 text-sm font-medium text-gray-500 hover:text-gray-700'
                  aria-current={page.current ? 'page' : undefined}
                >
                  {page.name}
                </Link>
              ) : (
                <span className='ml-4 text-sm font-medium text-gray-500'>
                  {page.name}
                </span>
              )}
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}
